import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionLobby } from "../shared/models/lobby.permission.model";
import { MapSinglePermissionModelToPermissionAdmin } from "../shared/mapper/single-permission-model-to-permission-admin.mapper";

export function getViewModleForPermissions(
  model: SinglePermissionModel[] /*, isEditingMode: boolean*/,
  viewMode: number /*= ViewPermission.FullAccess*/,
  groupPermission?: number[]
): PermissionLobby {
  let permissionLobby = new PermissionLobby();
  let editLobby = model.find((p) => p?.permissionId === 46);
  let viewLobby = model.find((p) => p?.permissionId === 47);
  let ForceSingOut = model.find((p) => p?.permissionId === 48);
  let accessQueues = model.find((p) => p?.permissionId === 106);

  permissionLobby.selectAllPermissionLobby = {
    Selected: true,
    Enabled: true,
    Id: 998,
    DisplayName: "",
  };

  permissionLobby.General = {
    selectAll: false,

    editLobby: MapSinglePermissionModelToPermissionAdmin(
      editLobby,
      46,
      viewMode,
      groupPermission
    ),

    viewCentralViews: MapSinglePermissionModelToPermissionAdmin(
      viewLobby,
      47,
      viewMode,
      groupPermission
    ),

    forceSignOutUsers: MapSinglePermissionModelToPermissionAdmin(
      ForceSingOut,
      48,
      viewMode,
      groupPermission
    ),
    accessAllQueues: MapSinglePermissionModelToPermissionAdmin(
      accessQueues,
      106,
      viewMode,
      groupPermission
    ),
  };

  let viewCheclist = model.find((p) => p?.permissionId === 49);
  let addchecklist = model.find((p) => p?.permissionId === 50);
  let editCheckList = model.find((p) => p?.permissionId === 51);
  let deleteChecklist = model.find((p) => p?.permissionId === 52);

  permissionLobby.Checklist = {
    selectAll: false,

    viewChecklist: MapSinglePermissionModelToPermissionAdmin(
      viewCheclist,
      49,
      viewMode,
      groupPermission
    ),

    addChecklist: MapSinglePermissionModelToPermissionAdmin(
      addchecklist,
      50,
      viewMode,
      groupPermission
    ),

    editCheckList: MapSinglePermissionModelToPermissionAdmin(
      editCheckList,
      51,
      viewMode,
      groupPermission
    ),

    deleteChecklist: MapSinglePermissionModelToPermissionAdmin(
      deleteChecklist,
      52,
      viewMode,
      groupPermission
    ),
  };

  let lwaView = model.find((p) => p?.permissionId === 53);
  let lwaAdd = model.find((p) => p?.permissionId === 54);
  let lwaEdit = model.find((p) => p?.permissionId === 55);
  let lwaDelete = model.find((p) => p?.permissionId === 56);

  permissionLobby.Lwa = {
    selectAll: false,

    lwaView: MapSinglePermissionModelToPermissionAdmin(
      lwaView,
      53,
      viewMode,
      groupPermission
    ),

    lwaAdd: MapSinglePermissionModelToPermissionAdmin(
      lwaAdd,
      54,
      viewMode,
      groupPermission
    ),

    lwaEdit: MapSinglePermissionModelToPermissionAdmin(
      lwaEdit,
      55,
      viewMode,
      groupPermission
    ),

    lwaDelete: MapSinglePermissionModelToPermissionAdmin(
      lwaDelete,
      56,
      viewMode,
      groupPermission
    ),
  };

  let txtConfigView = model.find((p) => p?.permissionId === 57);
  let txtConfigEdit = model.find((p) => p?.permissionId === 58);
  let txtConfigEnable = model.find((p) => p?.permissionId === 59);

  permissionLobby.TextConfiguration = {
    selectAll: false,

    textConfigView: MapSinglePermissionModelToPermissionAdmin(
      txtConfigView,
      57,
      viewMode,
      groupPermission
    ),

    textConfigEdit: MapSinglePermissionModelToPermissionAdmin(
      txtConfigEdit,
      58,
      viewMode,
      groupPermission
    ),

    textConfigEnable: MapSinglePermissionModelToPermissionAdmin(
      txtConfigEnable,
      59,
      viewMode,
      groupPermission
    ),
  };

  permissionLobby.General.selectAll =
    permissionLobby.General.editLobby.Selected &&
    permissionLobby.General.viewCentralViews.Selected &&
    permissionLobby.General.forceSignOutUsers.Selected &&
    permissionLobby.General.accessAllQueues.Selected;

  permissionLobby.Checklist.selectAll =
    permissionLobby.Checklist.viewChecklist.Selected &&
    permissionLobby.Checklist.addChecklist.Selected &&
    permissionLobby.Checklist.editCheckList.Selected &&
    permissionLobby.Checklist.deleteChecklist.Selected;

  permissionLobby.Lwa.selectAll =
    permissionLobby.Lwa.lwaView.Selected &&
    permissionLobby.Lwa.lwaAdd.Selected &&
    permissionLobby.Lwa.lwaEdit.Selected &&
    permissionLobby.Lwa.lwaDelete.Selected;

  permissionLobby.TextConfiguration.selectAll =
    permissionLobby.TextConfiguration.textConfigView.Selected &&
    permissionLobby.TextConfiguration.textConfigEdit.Selected &&
    permissionLobby.TextConfiguration.textConfigEnable.Selected;

  permissionLobby.selectAllPermissionLobby.Selected =
    permissionLobby.General.selectAll &&
    permissionLobby.Checklist.selectAll &&
    permissionLobby.Lwa.selectAll &&
    permissionLobby.TextConfiguration.selectAll;

  return permissionLobby;
}

export function setSelectAllLobbyStatus(
  permissionLobby: PermissionLobby
): boolean {
  let enabled =
    checkLobbyGeneralStatus(permissionLobby) &&
    checkLobbyCheckListStatus(permissionLobby) &&
    checkLobbyLWAStatus(permissionLobby) &&
    checkLobbyTextStatus(permissionLobby);

  return enabled;
}

//Check for disabled and un-check fields in each sub category of lobby permissions section

function checkLobbyGeneralStatus(permissionLobby: PermissionLobby): boolean {
  let enabled = false;

  let editLobby = !permissionLobby.General.editLobby.Enabled;
  let viewCentralViews = !permissionLobby.General.viewCentralViews.Enabled;
  let forceSignOutUsers = !permissionLobby.General.forceSignOutUsers.Enabled;
  let accessAllQueues = !permissionLobby.General.accessAllQueues.Enabled;

  if (editLobby || viewCentralViews || forceSignOutUsers || accessAllQueues) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkLobbyCheckListStatus(permissionLobby: PermissionLobby): boolean {
  let enabled = false;

  let viewChecklist = !permissionLobby.Checklist.viewChecklist.Enabled;
  let addChecklist = !permissionLobby.Checklist.addChecklist.Enabled;
  let editCheckList = !permissionLobby.Checklist.editCheckList.Enabled;
  let deleteChecklist = !permissionLobby.Checklist.deleteChecklist.Enabled;

  if (viewChecklist || addChecklist || editCheckList || deleteChecklist) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkLobbyLWAStatus(permissionLobby: PermissionLobby): boolean {
  let enabled = false;

  let lwaView = !permissionLobby.Lwa.lwaView.Enabled;
  let lwaAdd = !permissionLobby.Lwa.lwaAdd.Enabled;
  let lwaEdit = !permissionLobby.Lwa.lwaEdit.Enabled;
  let lwaDelete = !permissionLobby.Lwa.lwaDelete.Enabled;

  if (lwaView || lwaAdd || lwaEdit || lwaDelete) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkLobbyTextStatus(permissionLobby: PermissionLobby): boolean {
  let enabled = false;

  let textConfigView =
    !permissionLobby.TextConfiguration.textConfigView.Enabled;
  let textConfigEdit =
    !permissionLobby.TextConfiguration.textConfigEdit.Enabled;
  let textConfigEnable =
    !permissionLobby.TextConfiguration.textConfigEnable.Enabled;

  if (textConfigView || textConfigEdit || textConfigEnable) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}
